module.exports = __webpack_public_path__ + "img/bj4.efe6fe22.png";